let lazyLoadInstances = [];
export default lazyLoadInstances;